import React, { useCallback } from "react";
import AddCardEvent from "../components/LiveTicker/CardEvent/AddCardEvent";
import EditCardEvent from "../components/LiveTicker/CardEvent/EditCardEvent";

export const usePlayerCard = (setEventDetails) => {
    const handlePlayerCard = useCallback((player, confirmCallback, initialEvent, isStaff) => {
      const fullName = `${player.firstName} ${player.lastName}`;
      const selectedPlayer = {
        ...player,
        ...(isStaff ? { staff: true } : {}),
        playerName: fullName,
      };
  
      setEventDetails((data) => ({
        ...data,
        playerSelected: selectedPlayer,
        type:
          data?.type?.name === "GELB" &&
          ((player.cards || []).includes("GELB") ||
          (player.cards || []).includes("GELB ROT"))
          ? {
            name: `GELB ROT`,
            background: "linear-gradient(-45deg, #FF0014 50%, #F8D200 50%)",
            addComponentToOpen: AddCardEvent,
            editComponentToOpen: EditCardEvent,
          }
          : initialEvent.current.type,
      }));
  
      confirmCallback && confirmCallback();
    }, [setEventDetails]);
  
    return handlePlayerCard;
};